import { 
  BrowserRouter, 
  Routes, 
  Route, 
  Navigate 
} from 'react-router-dom';
import { RootLayout } from './layouts/RootLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { DashboardLayout } from './layouts/DashboardLayout';

// Auth Pages
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';

// Dashboard Pages
import { Home } from './pages/dashboard/Home';
import { Governance } from './pages/dashboard/Governance';
import { Feed } from './pages/dashboard/Feed';
import { Connections } from './pages/dashboard/Connections';
import { Profile } from './pages/dashboard/Profile';
import { Settings } from './pages/dashboard/Settings';

// Welcome Page
import { Welcome } from './pages/Welcome';

// Marketing / Legal Pages
import { Services } from './pages/marketing/Services';
import { Features } from './pages/marketing/Features';
import { About } from './pages/marketing/About';
import { Careers } from './pages/marketing/Careers';
import { Press } from './pages/marketing/Press';
import { FAQ } from './pages/marketing/FAQ';
import { Contact } from './pages/marketing/Contact';
import { Privacy } from './pages/marketing/Privacy';
import { Terms } from './pages/marketing/Terms';
import { Cookies } from './pages/marketing/Cookies';

const Placeholder = ({ title }: { title: string }) => (
  <div className="flex h-full items-center justify-center">
    <div className="text-center">
      <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
      <p className="text-slate-500">This page is under construction.</p>
    </div>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RootLayout />}>
          {/* Public Routes */}
          <Route path="/" element={<Welcome />} />

          {/* Marketing / Legal */}
          <Route path="/services" element={<Services />} />
          <Route path="/features" element={<Features />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/press" element={<Press />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />

          {/* Auth Routes */}
          <Route path="/auth" element={<AuthLayout />}>
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot-password" element={<Placeholder title="Forgot Password" />} />
            <Route path="biometric-setup" element={<Placeholder title="Biometric Setup" />} />
            <Route index element={<Navigate to="/auth/login" replace />} />
          </Route>

          {/* Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Home />} />
            <Route path="feed" element={<Feed />} />
            <Route path="connections" element={<Connections />} />
            <Route path="governance" element={<Governance />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Root Redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}